import { useState } from "react";
import { Download } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { Button } from "@/components/ui/button";

export const HOMEOWNER_TYPES: Record<string, string> = { lead: "Lead", quoted: "Quoted", customer: "Customer" };
const COLS: [string, string][] = [["name", "Name"], ["type", "Type"], ["address", "Address"], ["city", "City / Region"], ["email", "Email"], ["phone", "Phone"], ["notes", "Project notes"], ["created_at", "Created"], ["id", "ID"]];
const cell = (v: any) => { const s = v == null ? "" : String(v); return /[",\n\r]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s; };

export function HomeownerExport() {
  const [busy, setBusy] = useState(false);
  const run = async () => {
    setBusy(true);
    try {
      const r = await api.get("/homeowners");
      const rows: any[] = r.data;
      const lines = [COLS.map(([, l]) => l).join(","), ...rows.map((h) => COLS.map(([k]) => cell(k === "type" ? HOMEOWNER_TYPES[h.type || "lead"] || h.type : h[k])).join(","))];
      const blob = new Blob(["\ufeff" + lines.join("\r\n")], { type: "text/csv;charset=utf-8" });
      const a = document.createElement("a"); a.href = URL.createObjectURL(blob); a.download = `homeowners_${new Date().toISOString().slice(0, 10)}.csv`; a.setAttribute("data-testid", "homeowners-export-link"); document.body.appendChild(a); a.click(); a.remove();
      toast.success(`Exported ${rows.length} homeowner${rows.length === 1 ? "" : "s"}`);
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return <Button size="sm" variant="outline" data-testid="homeowners-export-btn" disabled={busy} onClick={run}><Download size={14} className="mr-1.5" />{busy ? "Exporting…" : "Export CSV"}</Button>;
}
